import React from 'react';
import styled, { css } from 'styled-components/macro';

const loader = (): any => css<any>`
  transition: opacity 0.5s ease-in-out;
  background: white;
  opacity: ${({ loading }): number => (loading ? 0.5 : 1)};
  pointer-events: ${({ loading }): string => (loading ? 'none' : 'initial')};
`;

export const StyledDiv = (props: any): any => {
  const { className, children, ...rest } = props;
  delete rest.loading;
  delete rest.browseRelated;
  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};

const StyledGroup = (props: any): any => {
  const { className, children, ...rest } = props;
  delete rest.loading;
  return (
    <g className={className} {...rest}>
      {children}
    </g>
  );
};

const AnimatedLoadingWrapper = styled(StyledDiv)<any>`
  ${({ browseRelated }): string =>
    browseRelated ? 'padding: 0 !important; margin-top: 15px;' : ''}
  ${loader}
`;

export const AnimatedLoadingWrapperGroup = styled(StyledGroup)`
  ${loader}
`;

export default AnimatedLoadingWrapper;
